/**
 * WordPress dependencies
 */
import { Fragment, useRef, useCallback } from '@wordpress/element';
import {
	JustifyContentControl,
} from '@wordpress/block-editor';
import {
	ToolbarGroup,
} from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import URLPicker from '../../../components/URLPicker';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

const UrlPicker = ( props ) => {
	const { attributes, onChange, isSelected } = props;
	const { url, linkTarget, rel } = attributes;
	const NEW_TAB_REL = 'noreferrer noopener';
	const ref = useRef();
	const onToggleOpenInNewTab = useCallback(
		( value ) => {
			const newLinkTarget = value ? '_blank' : undefined;

			let updatedRel = rel;
			if ( newLinkTarget && ! rel ) {
				updatedRel = NEW_TAB_REL;
			} else if ( ! newLinkTarget && rel === NEW_TAB_REL ) {
				updatedRel = undefined;
			}

			const data = {
				linkTarget: newLinkTarget,
				rel: updatedRel,
			};
			onChange( data );
		},
		[ rel ]
	);
	return <URLPicker
		url={ url }
		updateBlock={ ( data ) => {
			onChange( data );
		} }
		isSelected={ isSelected }
		opensInNewTab={ linkTarget === '_blank' }
		onToggleOpenInNewTab={ onToggleOpenInNewTab }
		anchorRef={ ref }
	/>;
};

addFilter(
	`gutenify-block-${ hookPrefix }-block-controls`,
	`Gutenify/Block/${ hookPrefix }/BlockControls/BasicControls`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { contentJustification, orientation } = attributes;
		const VERTICAL_JUSTIFY_CONTROLS = [ 'left', 'center', 'right' ];
		const HORIZONTAL_JUSTIFY_CONTROLS = [
			'left',
			'center',
			'right',
			// 'space-between',
		];
		const justifyControls =
			orientation === 'vertical'
				? VERTICAL_JUSTIFY_CONTROLS
				: HORIZONTAL_JUSTIFY_CONTROLS;

		return [
			...content,
			<Fragment /* translators: block settings */
				key="gutenify-block-icon-block-controls-basic-controls"
			>
				<ToolbarGroup>

					<JustifyContentControl
						allowedControls={ justifyControls }
						value={ contentJustification }
						onChange={ ( value ) => setAttributes( { contentJustification: value } ) }
						popoverProps={ {
							position: 'bottom right',
							isAlternate: true,
						} }
					/>
				</ToolbarGroup>
				<UrlPicker { ...props } onChange={ ( data ) => {
					setAttributes( data );
				} } />
			</Fragment>,
		];
	}
);
